import {
  collection,
  query,
  where,
  getDocs,
  getDoc,
  doc,
  orderBy,
} from "firebase/firestore";
import CryptoJS from "crypto-js";
import * as XLSX from "xlsx";
import { Button, Modal, Table, message } from "antd";
import { useState } from "react";
import { Document, Text, Page, StyleSheet, View, Image } from '@react-pdf/renderer';
import qr from "../assets/img/qr-code.png";

export const APP_VERSION = "0.5.9";

/* lists */

// order status list
export const statusList = {
  Entregado: { color: "#52c41a" },
  Preparado: { color: "#00FF00" },
  "Pendiente de stock": { color: "#faad14" },
  Pagado: { color: "#FFA500" },
  Reservado: { color: "#2f54eb" },
  Fallido: { color: "#f5222d" },
  "Por Recoger": { color: "#1890ff" },
  "No hay stock": { color: "#d9d9d9" },
  Llamar: { color: "#722ed1" },
  Devolucion: { color: "#ad8b00" },
  Cancelado: { color: "#f5222d" },
  Agendado: { color: "#13c2c2" },
  Pendiente: { color: "#f2433d" },
  "En ruta": { color: "#004d80" },
  "Llamado": { color: "#008080" }
};

// confirm status list
export const confirmStatusList = {
  noAnswer: "No contestan llamada",
  confirmedDelivery:"Confirma entrega",
  wrongNumber: "Numero equivocado",
  blockedOff: "Numero apagado / bloqueado",
  rescheduled: "Reprogramado",
  cancelPurchase: "Desiste de la compra",
  denyPurchase: "Niega la compra"
};

// cancel reasons
export const reasonsList = {
  unknown: "No aplica",
  outStock: "No hay stock",
  shippingDelay: "Demora en entrega",
  badQuality: "Mala calidad",
  damaged: "Se le daño el producto -30 días",
  others: "Otros motivos",
  priceDelivery: "Muy caro el envio",
  dangerousZone: "Zona Peligrosa",
  unReilable: "Cliente No confiable para Contraentrega",
  theft: "Robo por motorizado",
  dontLikeIt: "No le gusto el producto"
}

// relationship list
export const relationshipList = {
  family: "Familiar",
  spouse: "Conyuge/Pareja",
  friend: "Amigo/a",
  other: "Otro/a"
}

// roles
export const roles = {
  admin: "Administrador",
  op: "Operaciones",
  sales: "Vendedor",
  marketing: "Marketing",
  store: "Almacen",
  customerService: "Servicio al cliente",
  courier: "Courier"
}

// Generos
export const genders = {
  male: "Masculino",
  female: "Femenino",
  other: "Otro"
}

// collections
export const collections = {
  orders: "orders",
  couriers: "couriers",
  payment_types: "paymenttype",
  delivery_points: "delivery",
  sale_channels: "channel",
  closing_channels: "salesclosingchannel",
  brands: "brand",
  categories: "productcategory",
  sizes: "sizes"
};

export const categories = {
  BOTINES: "Botines",
  ROPA: "Ropa",
  OXFORD: "Oxford",
  ACCESORIOS: "Accesorios",
  ZAPATILLAS: "Zapatillas",
  PLATAFORMA: "Plataforma",
  BALERINAS: "Balerinas",
  SANDALIAS: "Sandalias",
};

export const brands = {
  ILARI: "Ilari",
  FELARI: "Felari",
  XIMO: "Ximo",
  ACEITE_JUANA: "Aceite Juana",
  NAYA: "Naya",
  KUNCA: "Kunca",
  ARANNI: "Aranni",
  ZIOL: "Ziol",
}

// check values en firebase
export const checkValueFirebase = async (
  db,
  collectionName,
  field,
  value,
  mode
) => {
  const search = query(
    collection(db, collectionName),
    where(field, "==", value)
  );
  const records = await getDocs(search);
  if (mode === "data") {
    return records;
  }
  return !records.empty;
};

// format docs
export const mapDocs = (res) => {
  return res.docs.map((ele) => ({ key: ele.id, ...ele.data() }));
};

// set states with firebase data
export const getRecords = async (db, list, setList, sortField, sortMode = "asc") => {
  let dbData;
  if (sortField) {
    dbData = await getDocs(query(collection(db, list), orderBy(sortField, sortMode)));
  } else {
    dbData = await getDocs(collection(db, list));
  }
  await setList(mapDocs(dbData));
}

export const mapDocsBoard = async (res) => {
  const docs = await Promise.all(
    res.docs.map(async (doc) => {
      const data = doc.data();
      const itemsRef = collection(doc.ref, "items");
      const itemsSnapshot = await getDocs(itemsRef);
      const itemsData = itemsSnapshot.docs.map((itemDoc) => ({
        id: itemDoc.id,
        ...itemDoc.data(),
      }));
      return {
        key: doc.id,
        ...data,
        items: itemsData,
      };
    })
  );
  return docs;
};

// format firebase timestamps
export const formatTimestamp = (timestamp, mode = "date") => {
  const date = timestamp.toDate();
  const year = date.getFullYear().toString().padStart(4, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');

  if (mode === "date") {
    return `${day}/${month}/${year}`;
  }

  if (mode === "hour") {
    return `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`;
  }
};

export const getSerial = async (db) => {
  try {
    const q = query(collection(db, "orders"), where("serial", "!=", null));
    const snapshot = await getDocs(q);
    const serialNumber = snapshot.size + 1;
    return `${serialNumber.toString().padStart(5, "0")}`;
  } catch (error) {
    message.error("Error generando serial, contacte con el administrador");
    console.error(error);
  }
};

// select type of size by category
export const checkCategory = (category) => {
  if (
    category.toUpperCase() === "BOTINES" ||
    category.toUpperCase() === "ZAPATILLAS" ||
    category.toUpperCase() === "SANDALIAS" ||
    category.toUpperCase() === "PLATAFORMA" ||
    category.toUpperCase() === "BALERINAS" ||
    category.toUpperCase() === "OXFORD" ||
    category.toUpperCase() === "PANTUFLAS"
  ) {
    return "CALZADO";
  }

  if (category.toUpperCase() === "ROPA" ||
    category.toUpperCase() === "PANTALONES" ||
    category.toUpperCase() === "CAMISAS" ||
    category.toUpperCase() === "CHALECOS" ||
    category.toUpperCase() === "VESTIDOS" ||
    category.toUpperCase() === "ENTERIZOS" ||
    category.toUpperCase() === "FALDAS" ||
    category.toUpperCase() === "TOPS" ||
    category.toUpperCase() === "SHORTS" ||
    category.toUpperCase() === "BLUSAS" ||
    category.toUpperCase() === "BLAZER" ||
    category.toUpperCase() === "CHOMPAS" ||
    category.toUpperCase() === "SACOS"
  ) {
    return "ROPA";
  }

  if (category.toUpperCase() === "ACCESORIOS" ||
    category.toUpperCase() === "BOLSOS" ||
    category.toUpperCase() === "BILLETERAS"
  ) {
    return null;
  }
};

// fetch user data
export const getUserData = async (db, id) => {
  const userRef = doc(db, "user", id);
  const userSnap = await getDoc(userRef);
  return userSnap.data();
};

export const fetchData = async (db, table, setData) => {
  const data = await getDocs(collection(db, table));
  setData(mapDocs(data));
}

const key = "pxN7`:A.v>}?vL`Hv`GZY$+=2R5AX@";

// encrypt values
export const encrypt = async (value) => {
  return CryptoJS.AES.encrypt(value, key).toString();
}

// decrypt values
export const decrypt = async (value) => {
  if (value) {
    const bytes = CryptoJS.AES.decrypt(value, key);
    return bytes.toString(CryptoJS.enc.Utf8);
  }
}

export function useOrderPercentage(filteredOrders, totalSalesForDateRange) {
  const calculatePercentage = () => {
    const salesForFilteredOrders = filteredOrders?.reduce(
      (accumulator, current) => accumulator + current.saleAmount,
      0
    );

    return ((salesForFilteredOrders / totalSalesForDateRange) * 100).toFixed(2);
  };

  return calculatePercentage();
}

export function copyDataToClipboard(data) {
  const el = document.createElement('textarea');
  el.value = data;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
}

export function ExportToExcel({ data, fileName, columns, name = "Vista previa" ,showView=true}) {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const [visible, setVisible] = useState(false);

  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(data);
    link.download = fileName + fileExtension;
    link.click();
  };

  const showModal = () => {
    setVisible(true);
  };

  const closeModal = () => {
    setVisible(false);
  };

  return (
    <>
      <Button onClick={showModal}>{name}</Button>
      <Modal
        title="Vista previa de la descarga"
        open={visible}
        onOk={() => {
          exportToCSV(data, fileName);
          closeModal();
        }}
        onCancel={closeModal}
        width={1200}
        okText="Descargar"
      >
        {showView ? <div className="overflow-x-auto h-96">
          <Table
            dataSource={data}
            columns={columns}
            pagination={false}
            scroll={{
              y: 300
            }}
          />
        </div> : <p>demasiados registros para mostrar</p>}
      </Modal>
    </>
  );
}

export const OrderReport = ({ orderData }) => {
  const styles = StyleSheet.create({
    page: {
      margin: "0 2 5 2",
      display: "flex",
    },
    layout: {
      flexDirection: 'column',
      justifyContent: 'space-evenly',
    },
    header: {
      padding: "5 5 0 5",
      flexDirection: "column",
      justifyContent: "space-evenly",
      alignItems: "left",
      borderBottom: "2px solid black",
      marginRight: 5,
    },
    customerName: {
      fontSize: 14,
      marginBottom: 5
    },
    customerItem: {
      fontSize: 9,
      marginBottom: 5
    },
    listTitle: {
      fontSize: 9,
    },
    list: {
      fontSize: 9,
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "left",
      borderBottom: "2px solid black",
      marginRight: 5,
      flexWrap: "wrap",
      padding: "5 5 0 5",
    },
    item: {
      marginTop: 2,
      marginLeft: 2,
      marginRight: 2,
      marginBottom: 2,
    },
    total: {
      flexDirection: "column",
      justifyContent: "space-evenly",
      alignItems: "left",
      fontSize: 9,
      marginRight: 5,
      borderBottom: "2px solid black",
      padding: "5 5 0 5",
    },
    totalItem: {
      margin: "2 0 2 0"
    },
    channel: {
      fontSize: 8,
      flexDirection: "column",
      justifyContent: "space-evenly",
      alignItems: "center",
      borderBottom: "2px solid black",
      marginRight: 5,
      padding: "5 5 0 5",
    },
    channelItem: {
      marginBottom: 5,
    },
    lowSection: {
      flexDirection: "row",
      justifyContent: "space-evenly",
      alignItems: "center"
    },
    footer: {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "left",
      padding: "5 5 0 0",
    },
    footerItem: {
      fontSize: 9,
    },
    timestamp: {
      fontSize: 9,
      paddingTop: 5,
      textAlign: "center",
    },
    image: {
      width: 35,
      height: 35,
      marginTop: 5,
    }
  });

  const timestamp = new Date();
  const date = timestamp.getDate();
  const month = timestamp.getMonth() < 11 ? `0${timestamp.getMonth() + 1}` : timestamp.getMonth() + 1;
  const year = timestamp.getFullYear();
  const hour = timestamp.getHours();
  const minute = timestamp.getMinutes() < 10 ? `0${timestamp.getMinutes()}` : timestamp.getMinutes();
  const second = timestamp.getSeconds() < 10 ? `0${timestamp.getSeconds()}` : timestamp.getSeconds();
  const delivery = Number(orderData.shippingAmount).toFixed(2);
  const saleAmount = Number(orderData.saleAmount).toFixed(2);
  const payable = Number(orderData.payable).toFixed(2);
  const total = Number(orderData.saleAmount + orderData.shippingAmount).toFixed(2);

  return (
    <Document>
      <Page size={"A7"} style={styles.page}>
        <View style={styles.layout}>
          <View style={styles.header}>
            <Text style={styles.customerName}> #{orderData.serial} {orderData.customerName}</Text>
            <Text style={styles.customerItem}>{orderData.address}</Text>
            <Text style={styles.customerItem}>{orderData.district}</Text>
            <Text style={styles.customerItem}>{orderData.province}</Text>
            <Text style={styles.customerItem}>{orderData.department}</Text>
            <Text style={styles.customerItem}>{orderData.phoneNumber}</Text>
          </View>
          <View style={styles.channel}>
            <Text style={styles.channelItem}>{orderData.channel}</Text>
            <Text style={styles.channelItem}>{orderData.managementtype}</Text>
          </View>
          <View style={styles.list}>
            {orderData.products?.map((product, index) => {
              return <View style={styles.item}>
                <Text>{` ${index + 1}. ${product.category} - ${product.brand} - ${product.model} - ${product.color} - ${product.size} x ${product.quantity} und`}</Text>
              </View>
            })}
          </View>
          <View style={styles.total}>
            <Text style={styles.totalItem}>Total : ${total}</Text>
            <Text style={styles.totalITem}>Costo producto : ${saleAmount}</Text>
            <Text style={styles.totalItem}>Costo envio : ${delivery}</Text>
            <Text style={styles.totalItem}>Pendiente por pagar : ${payable}</Text>
          </View>
          <View style={styles.lowSection}>
            <View style={styles.footer}>
              <Text style={styles.footerItem}>RUC 20609605601</Text>
              <Text style={styles.footerItem}>Corporación ARANNI SAC</Text>
              <Text style={styles.footerItem}>Lima - Perú</Text>
              <Text style={styles.footerItem}>Atención al cliente : 970334874</Text>
            </View>
            <View>
              <Image style={styles.image} src={qr} />
            </View>
          </View>
          <View style={styles.timestamp}>
            <Text>Impreso en : {`${date}/${month}/${year} - ${hour} : ${minute} : ${second} `}</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
}

export const calculateOrder = (orderData) => {
  console.log(orderData);
  let saleAmount = 0;
  if(typeof orderData?.products !== "undefined" && orderData?.products.length){
    for(let i = 0; i < orderData.products.length;i++){
      saleAmount += Number(orderData.products[i]["total"])
    }
  }
  let payableAmount = (Number(saleAmount) + Number(orderData.shippingAmount)) - Number(orderData.advanceDelivery);
  return {saleAmount,payableAmount};
}